// @flow
// document.body and document.documentElement are used both to work in different browsers

export const setScrollPositionWhileDragging = (element: ClientRect) => {
    if (document.documentElement && document.body) {
        const shiftX = element.right - document.documentElement.clientWidth;
        const shiftY = element.bottom - document.documentElement.clientHeight;
        if (shiftX > 0) {
            document.body.scrollLeft += shiftX;
            document.documentElement.scrollLeft += shiftX;
        }
        if (element.left <= 0) {
            document.body.scrollLeft += element.left;
            document.documentElement.scrollLeft += element.left;
        }
        if (shiftY > 0) {
            document.body.scrollTop += shiftY;
            document.documentElement.scrollTop += shiftY;
        }
        if (element.top <= 0) {
            document.body.scrollTop += element.top;
            document.documentElement.scrollTop += element.top;
        }
    }
};

export const checkIntersection = (rect: ClientRect, {top, bottom, right, left}: ClientRect): boolean =>
    !(top > rect.bottom || bottom < rect.top || right < rect.left || left > rect.right);
